var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { getActiveWalletPlanSuccess, getActiveWalletPlanFailure, GET_ACTIVE_WALLET_PLAN_REQUEST } from "../../actions";
import APIIN from "@/utils/APIIN";
const onGetActivePlanData = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        console.log("Fetching active plan data for tenantId:", action.payload.tenantId);
        try {
            APIIN.getCompany(`/company/admin/billing/tier?tenantId=${action.payload.tenantId}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchActivePlanDataWorker(action) {
    try {
        const data = yield call(onGetActivePlanData, action);
        yield put(getActiveWalletPlanSuccess(data));
    }
    catch (error) {
        yield put(getActiveWalletPlanFailure(error));
    }
}
export function* watchActivePlanData() {
    yield takeLatest(GET_ACTIVE_WALLET_PLAN_REQUEST, fetchActivePlanDataWorker);
}
